import { render, staticRenderFns } from "./ModificarRegistroOdontograma.vue?vue&type=template&id=c7c1f1e4&scoped=true"
import script from "./ModificarRegistroOdontograma.vue?vue&type=script&lang=js"
export * from "./ModificarRegistroOdontograma.vue?vue&type=script&lang=js"
import style0 from "./ModificarRegistroOdontograma.vue?vue&type=style&index=0&id=c7c1f1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c1f1e4",
  null
  
)

export default component.exports